import React, { useState } from 'react'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import FloCheckbox from 'src/components/common/form-elements/FloCheckbox'
import { Input } from '@shopflo/ui'
import { InputSlider } from 'src/components/common/slider/InputSlider'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { useCheckoutUI } from 'src/lib/contexts/CheckoutUIContext'

export const PrimaryButtonControl = () => {
  const {
    getters: { cartUIData },
    actions: { setCartUIConfigData, setShowUpiIconsOnCartButton }
  } = useCartContext()

  const {
    getters: { checkoutUI }
  } = useCheckoutUI()

  const handleConfigChange = (updates: Record<string, any>) => {
    setCartUIConfigData(
      {
        ...cartUIData.primaryCTAConfig,
        ...updates
      },
      'PRIMARY_CTA_CONFIG'
    )
  }

  return (
    <div className='flex flex-col gap-5'>
      <div className='flex flex-col gap-2'>
        <div className='grid grid-cols-2 gap-2'>
          <ColorPickerV2
            label='Background'
            color={cartUIData.primaryCTAConfig.backgroundColor ?? checkoutUI?.colorPalette?.primaryColor ?? '#FFFFFF'}
            onChange={color => handleConfigChange({ backgroundColor: color })}
          />
          <ColorPickerV2
            label='Text'
            color={cartUIData.primaryCTAConfig.textColor}
            onChange={color => handleConfigChange({ textColor: color })}
          />
        </div>
      </div>

      <InputSlider
        label='Border radius'
        value={cartUIData.primaryCTAConfig.borderRadius}
        onChange={value => handleConfigChange({ borderRadius: value })}
        min={0}
        max={50}
        step={1}
        showDots={true}
        dotCount={5}
        unit='px'
      />

      <div className='border-t border-zinc-950/6' />

      <Input
        label='CTA Label'
        maxSize={30}
        dimension='md'
        variant='outline'
        value={cartUIData.primaryCTAConfig.cartButtonCTAText}
        onChange={e => handleConfigChange({ cartButtonCTAText: e.target.value })}
        placeholder='Badge...'
        className='w-full'
      />

      <div className='flex items-center justify-between gap-3'>
        <div className='flex flex-col justify-center flex-1'>
          <p className='text-text-sm-medium text-zinc-600'>Highlight UPI icons</p>
          <p className='text-text-xs-medium text-zinc-500'>Helps reassure shoppers that UPI is available</p>
        </div>
        <FloCheckbox
          type='SWITCH'
          value={cartUIData.showUpiIconsOnCartButton}
          setValue={(value: boolean) => {
            setShowUpiIconsOnCartButton(value)
          }}
        />
      </div>
    </div>
  )
}
